/**
 * Temporary feature: Finder criterion carousel on the MacBook PLP.
 * Remove together with `FF_PLP_FINDER_ENABLED` once development is finished.
 */
export const ALLOWED_PLP_UUIDS: string[] = [
  // MacBook PLP prod
  'a059fa0c-b88d-4095-b6a2-dcbeb9dd5b33',
  // MacBook PLP preprod
  'd72d58f6-185e-429e-bb1e-4d5ba5262e79',
] as const
